function objectIsEmpty(obj) {
    if (!isObject(obj)) return undefined;
    return !Object.keys(obj).length;
}

function isObject(obj) {
    return typeof obj === "object";
}

function isArray(arr) {
    return Array.isArray(arr);
}

function isNumber(number) {
    return typeof number === "number";
}

function isString(str) {
    return typeof str === "string";
}

function isEmail(email) {
    if (!isString(email)) return false;
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(email);
}

class Mold {
    constructor(name, isRequired, isError, isEmpty) {
        this.name = name;
        this.isRequired = Boolean(isRequired);
        this.isError = isError || (() => false); // By default, a field can't have errors
        this.isEmpty = isEmpty || (v => !v && v !== 0); // By default, a field is empty if the value is falsy, but not 0
    }

    getResults(value, props) {
        const validity = {};
        if (this.isEmpty(value, props) && this.isRequired) {
            validity.empty = true;
        }
        if (!this.isEmpty(value, props) && this.isError(value, props)) {
            validity.error = true;
        }
        if (objectIsEmpty(validity)) return undefined;
        return validity;
    }
}

// TODO: remove
export const propertyFields = [
    {
        location: true,
        address: true,
    },
    {
        residenceType: true,
        rentRange: true,
        rent: true,
        moveInDate: true,
        sizeRange: true,
        size: true,
        moveOutDate: true,
        kitchen: true,
        waterTap: true,
        wc: true,
        shower: true,
        breakRoom: true,
        meetingRoom: true,
        lounge: true,
        lighting: true,
        naturalLight: true,
    },
    {
        driveIn: true,
        controlRoom24h: true,
        cameraSurveillance24h: true,
        parking: true,
        buildingInsurance: true,
        smartLock: true,
        propertyPics: true,
    },
    {
        firstName: true,
        lastName: true,
        phoneNumber: true,
        industries: true,
    },
    {
        creditRating: true,
        operatingMargin: true,
        employee: true,
        description: true,
    },
];

export const tenantPropertyFields = [
    {
        location: true,
        address: true,
    },
    {
        residenceType: true,
        rentRange: true,
        rent: true,
        moveInDate: true,
        sizeRange: true,
        size: true,
        moveOutDate: true,
        kitchen: true,
        waterTap: true,
        wc: true,
        shower: true,
        breakRoom: true,
        meetingRoom: true,
        lounge: true,
        lighting: true,
        naturalLight: true,
    },
    {
        driveIn: true,
        controlRoom24h: true,
        cameraSurveillance24h: true,
        parking: true,
        buildingInsurance: true,
        smartLock: true,
        propertyPics: true,
    },
    {},
    {
        firstName: true,
        lastName: true,
        phoneNumber: true,
        industries: true,
        workDetails: true,
        studentDetails: true,
    },
    {
        creditRating: true,
        companyName: true,
        operatingMargin: true,
        userEmployee: true,
        description: true,
    },
    {
        email: true,
        password: true,
        confirmPassword: true,
    },
];

// These are all the fields that both tenant and landlord use, that use the same types, and that can have some sort of error state
var propertyMold = [
    // Location fields
    new Mold(
        "location",
        true,
        v => !isObject(v) || (!isNumber(v.lat) || !isNumber(v.lng)),
        v => !v || objectIsEmpty(v)
    ),
    new Mold("address", true, v => !isString(v)),

    // Apartment type fields
    new Mold("moveInDate", true),

    // Profile fields
    new Mold(
        "industries",
        true,
        undefined,
        v => !isArray(v) || !v.some(e => Boolean(e) || e === 0)
    ),

    new Mold("description", false, v => !isString(v) || v.length > 300),
];

var landlordPropertyMold = [
    // Apartment type fields
    new Mold("residenceType", true),
    new Mold("rent", true, v => isNaN(Number(v))),
    new Mold("size", true, v => isNaN(Number(v))),
];

var tenantPropertyMold = [
    // Apartment type fields
    new Mold(
        "residenceType",
        true,
        undefined,
        v => !isObject(v) || !Object.values(v).some(e => Boolean(e) || e === 0)
    ),
    new Mold("rentMin", false, v => v !== undefined && isNaN(Number(v))),
    new Mold("rentMax", false, v => v !== undefined && isNaN(Number(v))),
    new Mold("sizeMin", false, v => v !== undefined && isNaN(Number(v))),
    new Mold("sizeMax", false, v => v !== undefined && isNaN(Number(v))),
    new Mold("rentRange", false, v => v !== undefined && (!isArray(v) || v.length !== 2 || isNaN(Number(v[0])) || isNaN(Number(v[1])))),
    new Mold("sizeRange", false, v => v !== undefined && (!isArray(v) || v.length !== 2 || isNaN(Number(v[0])) || isNaN(Number(v[1])))),

    // Profile fields
    new Mold("firstName", true),
    new Mold("lastName", true),
    new Mold("phoneNumber", true),
    new Mold(
        "timeInCountry",
        false,
        v => isNaN(Number(v)) || Number(v) < 0 || Number(v) > 999
    ),
    // new Mold( "description", false, v => !isString( v ) || v.length > 300 ),

    // Account fields
    new Mold("email", true, v => !isEmail(v), undefined),
    new Mold("password", true, v => !isString(v) || v.length < 8),
    new Mold(
        "confirmPassword",
        true,
        (v, props) => !isString(v) || v.length < 8 || v !== props.password
    ),
];

export function validateProperty(props, landlord) {
    let validity = {};
    for (let i = 0; i < propertyMold.length; i++) {
        let mold = propertyMold[i];
        const prop = mold.getResults(props[mold.name], props);
        if (prop) validity[mold.name] = prop;
    }
    if (landlord) {
        for (let i = 0; i < landlordPropertyMold.length; i++) {
            let mold = landlordPropertyMold[i];
            const prop = mold.getResults(props[mold.name], props);
            if (prop) validity[mold.name] = prop;
        }
    } else {
        for (let i = 0; i < tenantPropertyMold.length; i++) {
            let mold = tenantPropertyMold[i];
            const prop = mold.getResults(props[mold.name], props);
            if (prop) validity[mold.name] = prop;
        }
    }
    return validity;
}

const baseSignupMold = [
    // Account fields
    new Mold("email", true, v => !isEmail(v), undefined),
    new Mold("password", true, v => !isString(v) || v.length < 8),
    new Mold(
        "confirmPassword",
        true,
        (v, props) => !isString(v) || v.length < 8 || v !== props.password
    ),
];

export function validateBaseSignup(props) {
    let validity = {};
    for (let i = 0; i < baseSignupMold.length; i++) {
        let mold = baseSignupMold[i];
        const prop = mold.getResults(props[mold.name], props);
        if (prop) validity[mold.name] = prop;
    }
    return validity;
}

var propertiesEditorMold = [
    new Mold("location", true),
    new Mold("address", true),
    new Mold("rent", true, v => v !== undefined && isNaN(Number(v))),
    new Mold("size", true, v => v !== undefined && isNaN(Number(v))),
    new Mold("whenAvailable", true),
];

var landlordPropertiesEditorMold = [
    new Mold(
        "residenceType",
        true,
        v =>
            !v ||
            !Array.isArray(v) ||
            v.length !== 1 ||
            typeof v[0] !== "string"
    ),
    new Mold("description", true, v => !isString(v) || v.length > 600),
];

var tenantPropertiesEditorMold = [
    new Mold(
        "residenceType",
        true,
        v =>
            !v ||
            typeof v !== "object" ||
            !Object.values(v).some(value => value === true)
    ),
];

export function validatePropertiesEditor(props, landlord) {
    let validity = {};
    for (let i = 0; i < propertiesEditorMold.length; i++) {
        let mold = propertiesEditorMold[i];
        const prop = mold.getResults(props[mold.name], props);
        if (prop) validity[mold.name] = prop;
    }
    if (landlord) {
        for (let i = 0; i < landlordPropertiesEditorMold.length; i++) {
            let mold = landlordPropertiesEditorMold[i];
            const prop = mold.getResults(props[mold.name], props);
            if (prop) validity[mold.name] = prop;
        }
    } else {
        for (let i = 0; i < tenantPropertiesEditorMold.length; i++) {
            let mold = tenantPropertiesEditorMold[i];
            const prop = mold.getResults(props[mold.name], props);
            if (prop) validity[mold.name] = prop;
        }
    }
    return validity;
}

const privateTenantMold = [
    new Mold("private_firstName", true),
    new Mold("private_lastName", true),
];

const privateTenantEditMold = [
    new Mold("firstName", true),
    new Mold("lastName", true),
];

export const validatePrivateTenant = values => {
    let validity = {};
    privateTenantMold.forEach(mold => {
        const prop = mold.getResults(values[mold.name], values);
        if (prop) validity[mold.name] = prop;
    });
    return validity;
};

const organizationTenantMold = [
    new Mold("org_name", true),
    new Mold("org_businessId", true),
    new Mold("org_currentAddress", true),
    new Mold("org_contactFirstName", true),
    new Mold("org_contactLastName", true),
    new Mold("org_contactPhoneNumber", true),
    new Mold("org_contactEmail", true),
    new Mold("org_industry", true),
    new Mold("org_employeeCount", true, v => isNaN(Number(v)) || Number(v) < 0),
    new Mold("org_turnover", true, v => isNaN(Number(v)) || Number(v) < 0),
];

const organizationTenantEditMold = [
    new Mold("name", true),
    new Mold("businessId", true),
    new Mold("currentAddress", true),
    new Mold("contactFirstName", true),
    new Mold("contactLastName", true),
    new Mold("contactPhoneNumber", true),
    new Mold("contactEmail", true),
    new Mold("industry", true),
    new Mold("employeeCount", true, v => isNaN(Number(v)) || Number(v) < 0),
    new Mold("turnover", true, v => isNaN(Number(v)) || Number(v) < 0),
];

export const validateOrganizationTenant = values => {
    let validity = {};
    organizationTenantMold.forEach(mold => {
        const prop = mold.getResults(values[mold.name], values);
        if (prop) validity[mold.name] = prop;
    });
    return validity;
};

export function validateUserEditor(props, isPrivateTenant) {
    let validity = {};
    if (isPrivateTenant) {
        privateTenantEditMold.forEach(mold => {
            const prop = mold.getResults(props[mold.name], props);
            if (prop) validity[mold.name] = prop;
        });
    } else {
        organizationTenantEditMold.forEach(mold => {
            const prop = mold.getResults(props[mold.name], props);
            if (prop) validity[mold.name] = prop;
        });
    }
    return validity;
}
